/**
 * @generated SignedSource<<445531f8db38810de8e36caf8f427d18>>
 * @relayHash b2b13d3fd256f7379e65348c67b876da
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID b2b13d3fd256f7379e65348c67b876da

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "checkRecommendedOffer",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BackgroundStepQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BackgroundStepQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b2b13d3fd256f7379e65348c67b876da",
    "metadata": {},
    "name": "BackgroundStepQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "4b2bb0bd4aa5270fec771c53a7128105";

export default node;
